import React, { useEffect } from 'react';
import { Alert } from 'components/common';
import { useInventory, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { InventorySchema } from 'schemas';
import InventoryFormDumbOLD from './InventoryFormDumbOLD';


const InventoryCreateSmartOLD = () => {
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, postInventory } = useInventory();

  const defaultValues = {
    name: '',
    project: projects[0].value,
    additionalVariables: ''
  };

  const handleCloseAlert = () => cleanUpMessage();

  const findProject = (project) => {
    return projects.find(p => Number(p.value) === Number(project));
  }

  const handleCreate = (data) => {
    const inventory = new InventorySchema();
    inventory.setValues(data);
    inventory.values.fromEdit = false;
    const project = findProject(data.project);
    inventory.values.baseUrl = project.base_url;
    postInventory({
      body: inventory.getValues(),
    });
  };

  useEffect(() => {
    if (!!success.post) history.push(ROUTES.INVENTORY_LIST);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.post]);


  return (
    <>
      { projects && <InventoryFormDumbOLD defaultValues={defaultValues} handleOnSubmit={handleCreate} isEdit={false} />}
      <Alert severity="error" handleClose={handleCloseAlert} open={error.post} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(InventoryCreateSmartOLD));
